<template>
    <div class="flex justify-between mt-6 border-t border-gray-300">
        <div class="pt-4" v-if="totalValues">
            <strong>
                {{ state.currentPage[tableId] == 1 ? 1 : ((state.currentPage[tableId] - 1) * state.pageSize[tableId]) + 1 }}
            </strong>
            tot
            <strong>
                {{ state.currentPage[tableId] * state.pageSize[tableId] < totalValues ? state.currentPage[tableId] * state.pageSize[tableId] : totalValues }}
            </strong>
            van <strong>{{ totalValues }}</strong>
        </div>
        <div class="pager-buttons flex ml-auto pt-3">
            <div
                class="js-pager-button relative z-0 w-8 min-w-min border border-gray-300 -mr-px rounded-l-lg pt-1 pb-0.5 text-center font-bold transition"
                :class="state.currentPage[tableId] == 1 ? 'disabled text-gray-300 pointer-events-none' : 'text-gray-600 cursor-pointer hover:border-blue-dark-500 hover:bg-blue-light-500 hover:bg-opacity-20 hover:text-blue-dark-500'"
                @click="prevPage()"
            >
                <i class="fas fa-chevron-left fa-fw" aria-hidden="true"></i>
            </div>
            <template v-for="(n, index) in Math.ceil(totalValues / state.pageSize[tableId])" :key="tableId + state.currentPage[tableId] + index">
                <div
                    class="relative z-0 w-8 min-w-min border border-gray-300 text-gray-600 -mr-px pt-1 pb-0.5 text-center font-bold"
                    v-if="
                        n == 2
                        && state.currentPage[tableId] > 4
                        && Math.ceil(totalValues / state.pageSize[tableId]) > 7
                    "
                >
                    ...
                </div>
                <div
                    class="js-pager-button relative z-0 w-8 min-w-min border -mr-px pt-1 pb-0.5 text-center cursor-pointer font-bold hover:border-blue-dark-500 hover:bg-blue-light-500 hover:bg-opacity-20 hover:text-blue-dark-500 transition"
                    :class="n ==  state.currentPage[tableId] ? 'border-blue-dark-500 bg-blue-light-500 bg-opacity-20 text-blue-dark-500 z-10' : 'border-gray-300 text-gray-600'"
                    @click="goToPage(n)"
                    v-if="
                        n == 1
                        || n == Math.ceil(totalValues / state.pageSize[tableId])
                        || (n >= state.currentPage[tableId] - 1 && n <= state.currentPage[tableId] + 1)
                        || (n <= 5 && state.currentPage[tableId] < 5)
                        || (n >= Math.ceil(totalValues / state.pageSize[tableId]) - 4 && state.currentPage[tableId] > Math.ceil(totalValues / state.pageSize[tableId]) - 4)
                        || Math.ceil(totalValues / state.pageSize[tableId]) <= 7
                    "
                >
                    {{ n }}
                </div>
                <div
                    class="relative z-0 w-8 min-w-min border border-gray-300 text-gray-600 -mr-px pt-1 pb-0.5 text-center font-bold"
                    v-if="
                        n == Math.ceil(totalValues / state.pageSize[tableId]) - 1
                        && (totalValues / state.pageSize[tableId]) > 7
                        && state.currentPage[tableId] < (totalValues / state.pageSize[tableId]) - 3
                    "
                >
                    ...
                </div>
            </template>
            <div
                class="js-pager-button relative z-0 w-8 min-w-min border rounded-r-lg pt-1 pb-0.5 text-center font-bold transition"
                :class="state.currentPage[tableId] >= (totalValues / state.pageSize[tableId]) ? 'disabled text-gray-300 pointer-events-none' : 'text-gray-600 cursor-pointer hover:border-blue-dark-500 hover:bg-blue-light-500 hover:bg-opacity-20 hover:text-blue-dark-500'"
                @click="nextPage()"
            >
                <i class="fas fa-chevron-right fa-fw" aria-hidden="true"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

import store from "../store";
import { watch, ref } from "vue";
import {Inertia} from "@inertiajs/inertia";

export default {
    components: {
        Link
    },
    props: {
        values: {
            type: [Array, Object]
        },
        filters: {
            type: [Array, Object]
        },
        pageSize: {
            type: Number,
            required: true
        },
        totalResults: {
            type: Number,
        },
    },
    setup (props) {
        const tableId = store.state.currentTableId;//So we know to which table this paging belongs to
        let currentPage = (store.state.side[tableId] == 'server') ? props.values.current_page : 1
        let totalValues = ref((store.state.side[tableId] == 'server') ? props.values.total : store.state.allValues[tableId].length)

        // const urlQueryString = window.location.search
        // const urlParams = new URLSearchParams(urlQueryString);

        //Set initial values
        store.changePageSize({id: tableId, pageSize: props.pageSize});
        store.changeCurrentPage({id: tableId, currentPage: currentPage});
        store.sortValues({id: tableId});

        function prevPage() {
            if (store.state.side[tableId] == 'server') {
                getServerPage(store.state.currentPage[tableId] - 1)
            } else {
                //client side paging
                if (store.state.currentPage[tableId] > 1) {
                    store.changeCurrentPage({id: tableId, currentPage: store.state.currentPage[tableId] - 1});
                }

                store.sortValues({id: tableId});
            }
        }

        function nextPage() {
            if (store.state.side[tableId] == 'server') {
                getServerPage(store.state.currentPage[tableId] + 1)
            } else {
                //client side paging
                if ((store.state.currentPage[tableId] * store.state.pageSize[tableId]) < store.state.allValues[tableId].length) {
                    store.changeCurrentPage({id: tableId, currentPage: store.state.currentPage[tableId] + 1});
                }

                store.sortValues({id: tableId});
            }
        }

        function goToPage(n) {
            if (store.state.side[tableId] == 'server') {
                getServerPage(n)
            } else {
                //client side paging
                store.changeCurrentPage({id: tableId, currentPage: n})
                store.sortValues({id: tableId})
            }
        }

        //Only used for server side paging
        function getServerPage(pageNr)
        {
            Inertia.get(
                window.location.href,
                {
                    page: pageNr,
                    column: store.state.currentCol[tableId],
                    direction: store.state.currentDir[tableId],
                    search: store.state.currentSearch[tableId],//Table search
                    filters: store.state.currentFilters[tableId],//Table column search filters
                },
                {
                    replace: true,
                    preserveState: true,
                    onSuccess: () => {
                        store.changeCurrentPage({id: tableId, currentPage: pageNr})
                    }
                }
            )
        }

        // When values change
        watch(() => [props.values, store.state.allValues[tableId]], ([currentVals, currentStateVals], [oldVals, oldStateVals]) =>
        {
            store.changeCurrentPage({id: tableId, currentPage: 1})
            totalValues.value = (store.state.side[tableId] == 'server') ? props.values.total : store.state.allValues[tableId].length
        })

        return {
            state: store.state,
            ...store,
            tableId,
            totalValues,
            prevPage,
            nextPage,
            goToPage,
        };
    },
}
</script>

<style>
.pager-buttons div:not(.disabled):hover {
    z-index: 10;
}

</style>
